<div class="content-body">
  <div class="container-fluid">
    <div class="p-6">
      <div class="flex justify-between items-center mb-6">
        <h1 class="text-2xl font-semibold text-gray-900">Catálogo</h1>
        <button *ngIf="isAdmin" mat-stroked-button color="primary" (click)="openCreateProduct()">
          <mat-icon>add</mat-icon>
          Nuevo producto
        </button>
      </div>

      <!-- Loading state -->
      <div *ngIf="isLoading" class="flex justify-center items-center py-10">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500"></div>
      </div>

      <!-- Error state -->
      <div *ngIf="error" class="bg-red-50 border-l-4 border-red-500 p-4 mb-6">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-red-700">{{ error }}</p>
          </div>
        </div>
      </div>

      <!-- Empty state -->
      <div *ngIf="!isLoading && groups.length === 0" class="text-center py-16">
        <p class="text-gray-500 mb-4">No hay productos disponibles.</p>
        <button mat-raised-button color="primary" (click)="openCreateProduct()">
          <mat-icon class="mr-2">add</mat-icon>
          Crear primer producto
        </button>
      </div>

      <!-- Products list (Accordion by category) -->
      <div *ngIf="!isLoading && groups.length > 0" class="space-y-4">
        <div *ngFor="let group of groups; let i = index" class="border-2 border-orange-500 rounded-none shadow-md overflow-hidden bg-white">
          <!-- Card header with actions (edit to the left of chevron) -->
          <div class="w-full flex items-center justify-between py-3 px-4 transition-colors bg-orange-500 !text-white border-b-2 border-orange-600 font-semibold rounded-none"
               (click)="toggleCategory(i)" [attr.aria-controls]="'cat-panel-' + i" [attr.aria-expanded]="isOpen(i)" role="button" tabindex="0">
            <span class="text-sm md:text-lg font-semibold tracking-tight !text-white">{{ group.categoryName }}</span>
            <span class="ml-3 inline-flex items-center gap-1 !text-white">
              <!-- Enable/disable category (slide toggle) -->
              <mat-slide-toggle color="primary"
                                class="mr-1"
                                [checked]="isCategoryEnabled(group.categoryId)"
                                [disabled]="isCategoryUpdating(group.categoryId)"
                                (click)="$event.stopPropagation()"
                                (change)="onToggleCategoryEnabled(group, $event.checked)">
              </mat-slide-toggle>
              <mat-progress-spinner *ngIf="isCategoryUpdating(group.categoryId)" mode="indeterminate" diameter="16" strokeWidth="3" color="primary"></mat-progress-spinner>
              <!-- Botón para agregar producto a esta categoría -->
              <button *ngIf="isAdmin" mat-icon-button (click)="$event.stopPropagation(); openCreateProductForCategory(group)" aria-label="Agregar producto a la categoría">
                <mat-icon>add</mat-icon>
              </button>
              <!-- Edit just before chevron; stop toggle when clicked -->
              <!-- Optional delete (only without products); also stops toggle -->
              <button *ngIf="isAdmin && (group.items?.length || 0) === 0" mat-icon-button color="warn" (click)="$event.stopPropagation(); onDeleteCategory(group)" aria-label="Eliminar categoría">
                <mat-icon>delete</mat-icon>
              </button>
              <button *ngIf="isAdmin" mat-icon-button color="primary" (click)="$event.stopPropagation(); onRenameCategory(group)" aria-label="Editar categoría" [disabled]="isCategoryRenaming(group.categoryId)">
                <ng-container *ngIf="!isCategoryRenaming(group.categoryId); else editLoading">
                  <mat-icon>edit</mat-icon>
                </ng-container>
                <ng-template #editLoading>
                  <mat-progress-spinner mode="indeterminate" diameter="16" strokeWidth="3" color="primary"></mat-progress-spinner>
                </ng-template>
              </button>
              <mat-icon>{{ isOpen(i) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </span>
          </div>

          <!-- Card body -->
          <div [id]="'cat-panel-' + i" *ngIf="isOpen(i)" class="px-4 py-3 bg-white">
            <div class="catalog-admin-items max-h-admin overflow-y-auto pr-1">
              <app-editable-product-list
                [products]="group.items"
                [contextCategoryId]="group.categoryId"
                [contextCategoryName]="group.categoryName"
                [canEdit]="isAdmin"
                (update)="onUpdateProduct($event)"
                (delete)="onDeleteProduct($event)"
                (duplicate)="onDuplicateProduct($event, group)"
                class="mb-2"
              ></app-editable-product-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
